var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "名字" },
                model: {
                  value: _vm.paramsData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "name", $$v)
                  },
                  expression: "paramsData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { clearable: "", placeholder: "请选择年龄组" },
                  model: {
                    value: _vm.paramsData.age_group,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "age_group", $$v)
                    },
                    expression: "paramsData.age_group"
                  }
                },
                _vm._l(_vm.ageGroupList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.age_group, value: item.age_group }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addEvent.init()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" }
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
          _c("el-table-column", {
            attrs: { prop: "age_group", label: "年龄组" }
          }),
          _c("el-table-column", {
            attrs: { prop: "start_date_format", label: "开始时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "end_date_format", label: "结束时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "entry_fee", label: "费用" }
          }),
          _c("el-table-column", {
            attrs: { prop: "max_teams", label: "最大球队" }
          }),
          _c("el-table-column", {
            attrs: { prop: "registration_status_text", label: "赛事状态" }
          }),
          _c("el-table-column", {
            attrs: { prop: "format", label: "赛制规则" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.formatMap[row.format]))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "tournament_type", label: "赛事类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.tournamentMap[row.tournament_type]))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "赛事描述" }
          }),
          _c("el-table-column", {
            attrs: { prop: "reason", label: "取消原因" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.extra_info.reason))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "已报名球队" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "viewColor",
                        on: {
                          click: function($event) {
                            return _vm.$refs.signUpTeamList.init(row.id)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "260",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "x-c" },
                      [
                        scope.row.registration_status == "open"
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.addEvent.init(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(" 修改 ")]
                              ),
                              _c("div", {
                                staticClass: "controlsBtn-vertical"
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCancle(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v(" 取消 ")]
                              ),
                              _c("div", {
                                staticClass: "controlsBtn-vertical"
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleManageInfo(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v(" 配置信息 ")]
                              ),
                              _c("div", {
                                staticClass: "controlsBtn-vertical"
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.closeGenerate(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v(" 关闭报名 ")]
                              )
                            ]
                          : _vm._e(),
                        scope.row.registration_status != "cancelled" &&
                        scope.row.registration_status != "open"
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleMange(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v(" 赛程管理 ")]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": 10
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addEvent", {
        ref: "addEvent",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("addCancle", { ref: "addCancle" }),
      _c("addManage", {
        ref: "addManage",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("sign-up-team-list", { ref: "signUpTeamList" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }